import { useState, useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

// Components
import OrderTableMobil from '../OrderTableShoppingCartMobil';
import OrderTable from '../OrderTableShoppingCart';
import OrderTotals from '../ShoppingCartTotals';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import AlertConfirm from '../Consultancy/AlertConfirm';
import Alert from '../Alert';

import AlertMessage from '@mui/material/Alert';
import Collapse from '@mui/material/Collapse';
//import AddById from '../AddById';

// Queries
import postGlobal from '../Queries/postGlobal';
import closeSession from '../Queries/closeSession';

// Styles
import styles from './index.module.sass';

// Variables
const country = process.env.REACT_APP_COUNTRY;

export default function ShoppingCart({
  history,
  match,
  getCookie,
  webservice,
  device,
  addedArray,
  setAddedArray,
  setSessionMessage,
  orderData,
  setOrderData,
}) {
  const [loading, setLoading] = useState(false);
  const [finishLoading, setFinishLoading] = useState(false);
  const { orderMessage = '' } = useParams();
  const [openMessage, setOpenMessage] = useState(orderMessage === 'error');
  const [openConfirm, setOpenConfirm] = useState(false);

  const [alertOpen, setalertOpen] = useState(false);
  const [alertText, setAlertText] = useState('');

  const { t } = useTranslation('order');

  const { screenSize } = device;

  const getOrder = useCallback(
    async (action, cat, id, quantity, lineNum, neddLoading) => {
      setOpenConfirm(false);
      setLoading(neddLoading);
      const order = await postGlobal({
        tmbservice: 'getAgregarAlCarrito',
        jsonBody: {
          accion: action,
          usuarioOK: getCookie('usuarioOk'),
          folioPedido: getCookie('folioPedido'),
          almacen: getCookie('warehouse'),
          categoria: cat,
          clave: id,
          cantidad: quantity,
          numeroLinea: lineNum,
          textoProdSeleccion: '',
          idioma: window?.localStorage?.getItem('i18nextLng')?.includes('es') ? 0 : 1,
          origen: 'CARRITONUE',
        },
      });

      setOrderData(order || {});
      setLoading(false);

      setSessionMessage(order?.mensaje || '');
    },
    [getCookie, setSessionMessage, setOrderData],
  );

  useEffect(() => {
    if (getCookie('pedidoCerrado') === 'SI') {
      closeSession({ history });
    } else {
      getOrder(`${(country === 'MX' && 'CONSULTAR') || 'CONSTAXWEB'}`, '', '', '', '', true);
      window.scrollTo(0, 0);
    }
  }, [getOrder, getCookie, history, t]);

  function handleClose() {
    history.push('/cart');
  }

  useEffect(() => {
    if (orderData.situacionCierre === '' && orderData.situacionCierreMensaje !== '') {
      setAlertText(orderData.situacionCierreMensaje);
      setalertOpen(true);
    }
  }, [orderData.situacionCierre, orderData.situacionCierreMensaje]);

  return (
    <div className={`${styles.container} ${styles[screenSize]}`}>
      <Alert open={alertOpen} setOpen={setalertOpen} title={'Terramar'} text={alertText} />
      <AlertConfirm
        openConfirm={openConfirm}
        setOpenConfirm={setOpenConfirm}
        title={t('deleteCartAlertTitle')}
        text={t('deleteCartAlertText')}
        callback={() => {
          getOrder('BORRARDET', '', '', '', '', true);
        }}
        setLoading={setLoading}
      />
      <div className={styles.orderHeader}>
        <div className={styles.return} onClick={handleClose}>
          <i className='material-icons-outlined'>navigate_before</i>
          <span className={styles.returnText}>{t('return')}</span>
        </div>
      </div>
      {/* {screenSize !== 'phone' && (
        <div className={styles.addById}>
          <AddById
            screenSize={screenSize}
            webservice={webservice}
            getCookie={getCookie}
            addedArray={addedArray}
            setAddedArray={setAddedArray}
            setOrderData={setOrderData}
            setSessionMessage={setSessionMessage}
          />
        </div>
      )} */}

      {orderMessage === 'error' && (
        <div className={styles.alertMessage}>
          <Collapse in={openMessage}>
            <AlertMessage
              severity='error'
              action={
                <div className={styles.closeContainer}>
                  <span
                    className={`material-icons-outlined ${styles.closeMessage}`}
                    onClick={() => {
                      setOpenMessage(false);
                    }}>
                    close
                  </span>
                </div>
              }
              sx={{ mb: 2 }}>
              The transaction could not be concluded successfully, please try again
            </AlertMessage>
          </Collapse>
        </div>
      )}

      <div className={`${styles.orderDetail}`}>
        <div className={styles.content}>
          <div className={styles.leftRow}>
            {orderData?.situacionCierreMensaje && (
              <div className={`${styles.alertOrderData}`}>{orderData.situacionCierreMensaje}</div>
            )}
            {(loading && <CircularProgress className={styles.emptyLoading} />) || (
              <div className={styles.deleteAll}>
                <span
                  onClick={() => {
                    setOpenConfirm(true);
                  }}>
                  {t('emptyCart')}
                </span>
              </div>
            )}
            <div className={styles.orderTable}>
              {screenSize === 'phone' && (
                <OrderTableMobil
                  order={orderData}
                  getOrder={getOrder}
                  device={device}
                  loading={loading}
                />
              )}
              {screenSize !== 'phone' && (
                <OrderTable
                  order={orderData}
                  getOrder={getOrder}
                  device={device}
                  loading={loading}
                />
              )}
            </div>
          </div>
          <div className={styles.rightRow}>
            <div className={styles.orderTotals}>
              <OrderTotals
                totals={orderData?.totales || []}
                device={device || {}}
                loading={loading}
              />
            </div>

            {screenSize !== 'phone' && (
              <>
                <div className={styles.accionButton}>
                  <Button
                    type='submit'
                    variant='contained'
                    size='large'
                    color='primary'
                    className={styles.button2}
                    onClick={() => {
                      setFinishLoading(true);
                      history.push('/cart');
                    }}>
                    {t('keepBuying')}
                    {(finishLoading && <CircularProgress className={styles.finichLoading} />) || (
                      <i className={`material-icons ${styles.buttonIcon}`}>add_shopping_cart</i>
                    )}
                  </Button>
                </div>

                <div className={styles.accionButton}>
                  <Button
                    type='submit'
                    variant='contained'
                    size='large'
                    color='primary'
                    className={
                      (orderData.situacionCierre !== 'LISTO' && styles.disabled) || styles.button
                    }
                    onClick={() => {
                      setFinishLoading(true);
                      history.push('/cart/selectaddress');
                    }}
                    disabled={orderData.situacionCierre !== 'LISTO'}>
                    {t('closeAndPay')}
                    {(finishLoading && <CircularProgress className={styles.finichLoading} />) || (
                      <i className={`material-icons ${styles.buttonIcon}`}>trending_flat</i>
                    )}
                  </Button>
                </div>
              </>
            )}
          </div>
          {screenSize === 'phone' && (
            <div className={styles.accionButtonsMobile}>
              <div className={styles.accionButton}>
                <Button
                  type='submit'
                  variant='contained'
                  size='large'
                  color='primary'
                  className={styles.button2}
                  onClick={() => {
                    setFinishLoading(true);
                    history.push('/cart');
                  }}>
                  {t('keepBuying')}
                  {(finishLoading && <CircularProgress className={styles.finichLoading} />) || (
                    <i className={`material-icons ${styles.buttonIcon}`}>add_shopping_cart</i>
                  )}
                </Button>
              </div>

              <div className={styles.accionButton}>
                <Button
                  type='submit'
                  variant='contained'
                  size='large'
                  color='primary'
                  className={
                    (orderData.situacionCierre !== 'LISTO' && styles.disabled) || styles.button
                  }
                  onClick={() => {
                    setFinishLoading(true);
                    history.push('/cart/selectaddress');
                  }}
                  disabled={orderData.situacionCierre !== 'LISTO'}>
                  {t('closeAndPay')}
                  {(finishLoading && <CircularProgress className={styles.finichLoading} />) || (
                    <i className={`material-icons ${styles.buttonIcon}`}>trending_flat</i>
                  )}
                </Button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
